import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ONBOARDING } from "~/constants/routes";
import type { RyftOnboardingStepId } from "../types";
import { useRyftNonHostedOnboarding } from "./RyftNonHostedOnboardingProvider.shared";

export const RyftNonHostedOnboardingStepRedirect = ({
  stepId,
  children,
}: {
  stepId: RyftOnboardingStepId;
  children: ReactNode;
}) => {
  const { onboardingSteps } = useRyftNonHostedOnboarding();

  if (onboardingSteps[stepId] !== "current") {
    return (
      <Navigate to={BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ONBOARDING} replace />
    );
  }

  return <>{children}</>;
};
